import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { ReauthorizationCrecaRequestModel, ReauthorizationCrecaResponseModel } from "@/features/accounts/creca/services/reauthorization-model";

export class ReauthorizationCrecaApi {
  /**
   * クレカサイト認可画面要求(再認可)API
   */
  public reauthorizeCreca = async (
    param: ReauthorizationCrecaRequestModel
  ): Promise<ReauthorizationCrecaResponseModel> => {
    const path = `/api/crecaaccounts/authorization`;
    const res = await ApiClient.instance.get<ReauthorizationCrecaResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
